import { ZEntityErrorType } from "src/business/error/ZEntityError";

import { MfErrorRow } from "./MfErrorRow";

/*
https://wiki.axetechgroup.com/spaces/MDM20/pages/536346698/%D0%9E%D1%82%D0%BE%D0%B1%D1%80%D0%B0%D0%B6%D0%B5%D0%BD%D0%B8%D0%B5+%D1%81%D0%BF%D0%B8%D1%81%D0%BA%D0%B0+%D0%BE%D1%88%D0%B8%D0%B1%D0%BE%D0%BA+%D0%B2+%D0%BA%D0%B0%D1%80%D1%82%D0%BE%D1%87%D0%BA%D0%B5+%D0%BA%D0%BB%D0%B0%D1%81%D1%81%D0%B0+%D0%B7%D0%B0%D0%BF%D0%B8%D1%81%D0%B8#id-%D0%9E%D1%82%D0%BE%D0%B1%D1%80%D0%B0%D0%B6%D0%B5%D0%BD%D0%B8%D0%B5%D1%81%D0%BF%D0%B8%D1%81%D0%BA%D0%B0%D0%BE%D1%88%D0%B8%D0%B1%D0%BE%D0%BA%D0%B2%D0%BA%D0%B0%D1%80%D1%82%D0%BE%D1%87%D0%BA%D0%B5%D0%BA%D0%BB%D0%B0%D1%81%D1%81%D0%B0%2F%D0%B7%D0%B0%D0%BF%D0%B8%D1%81%D0%B8-%D0%A4%D1%83%D0%BD%D0%BA%D1%86%D0%B8%D0%BE%D0%BD%D0%B0%D0%BB%D1%8C%D0%BD%D1%8B%D0%B5%3A%D0%A2%D1%80%D0%B5%D0%B1%D0%BE%D0%B2%D0%B0%D0%BD%D0%B8%D1%8F(R)%2C%D0%9E%D0%B6%D0%B8%D0%B4%D0%B0%D0%BD%D0%B8%D1%8F(E)%2C%D0%94%D0%BE%D0%BF%D1%83%D1%89%D0%B5%D0%BD%D0%B8%D1%8F(A)%2C%D0%9E%D0%B3%D1%80%D0%B0%D0%BD%D0%B8%D1%87%D0%B5%D0%BD%D0%B8%D1%8F(L)
Сортировка
1. Техническая ошибка - отдельный первый блок в таблице:
  a. Все строки с "Тип" = "Техническая ошибка" выводятся в начале таблицы, до сортировки по атрибутам
  b. Внутри блока - порядок как в ответе Back
2. Атрибут - для строк с типами "Свойство атрибута "и "Бизнес":
  a. порядок атрибутов — как в полной схеме карточки
  b. строки одного атрибута (или одной вложенной группы) идут подряд
  c. строки без атрибута - в начале блока своего типа, перед строками с заполненным "Атрибут"
3. Тип ошибки ("Тип") - внутри каждого атрибута:
  a. Свойство атрибута
  b. Бизнес
4. Дополнение для "Свойство атрибута":
  a. Cначала Front-ошибки, затем Back-ошибки по тому же атрибуту
5. Уровень критичности ("Уровень критичности") - внутри "атрибут + тип":
  a. Error (Ошибка)
  b. Warning (Предупреждение)
6. Несколько Back строк на один атрибут - для любого типа (Техническая, Свойство атрибута, Бизнес):
  a. Порядок строк как в ответе Back
  b. При редактировании атрибута в карточке порядок в таблице не меняется до следующего нажатия "Сохранить"
*/
export const cmpErrors =
  (fieldIndices: Record<string, number>) =>
  (a: MfErrorRow, b: MfErrorRow): number => {
    // первыми всегда идут технические ошибки в том порядке, в котором они пришли с бэка
    if (a.type === ZEntityErrorType.tech && b.type === ZEntityErrorType.tech)
      return 0;
    if (a.type === ZEntityErrorType.tech) return -1;
    if (b.type === ZEntityErrorType.tech) return 1;

    // остальные ошибки сортируются по индексу атрибута на карточке. если индекса нет, то впереди
    const ai = a.path ? (fieldIndices[a.path] ?? -1) : -1;
    const bi = b.path ? (fieldIndices[b.path] ?? -1) : -1;
    if (ai !== bi) return ai - bi;

    // бизнес-правила позже ошибок валидации
    if (a.type !== b.type) {
      if (a.type === ZEntityErrorType.rule) return 1;
      if (b.type === ZEntityErrorType.rule) return -1;
    }

    if (!a.warning === !b.warning) return 0;
    if (a.warning) return 1;
    if (b.warning) return -1;

    return 0;
  };
